/*
 *
 *  remotes
 *
 */

import moment from "moment"
import api from "../../helpers/Api"
// import constantName from './key'

export function loadRecords(filter) {
 
  if (filter) {
    if (filter.fromDate && filter.toDate) {
      filter.fromDate = moment(filter.fromDate).format("YYYY-MM-DD")
      filter.toDate = moment(filter.toDate).format("YYYY-MM-DD")
    }
    filter.isManageHRMS = true
    if (filter.status == true) {
      filter.status = "Inactive"
    }
    console.log(filter, "filter")
    return api
      .post(`/get_all_employee`, filter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .post(`/get_all_employee`, { status: "active", isManageHRMS: true })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, type) {
  if (type === "get") {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecord(id) {
  return api
    .get(`/get_employe_by_id?employeeId=${id}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function createRecord(record) {
  return api
    .post(`/add_employee`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateRecord(record) {
  console.log(record, "qqqqqqqq")

  return (
    api
      // .put(`/update_employee_access_status_by_id`, record)
      .put(`/update_employee_by_id`, record)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  )
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteRecord(id) {
  return api
    .put(`/delete_employee_by_id?employeeId=` + id)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateStatus(record) {
  return api
    .delete(`/delete_employee_by_id`, record)
    .catch((error) => Promise.reject(error))
}
/**
 *
 * @param {object} record
 * @returns
 */
export function updateAccessStatus(record) {
  console.log(record, "record from access")

  return api
    .put(`/update_employee_access_status_by_id`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateSharedEmployeeDetails(record) {
  console.log(record, "record from access")

  return api
    .put(`/update_emp_shared_company_branch`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function updateProductDetails(record) {
  console.log(record, "record from access")

  return api
    .post(`/update_emp_operation_detail`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecords,
  loadRecordsMetaData,
  loadRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  updateStatus,
  updateAccessStatus,
  updateSharedEmployeeDetails,
  updateProductDetails
}

export default remotes
